import { actions as offline } from '../redux/ui/online';

export const initializeOfflineHandling = store => {
  window.onoffline = () => store.dispatch(offline.setOnline(false));
  window.ononline = () => store.dispatch(offline.setOnline(true));
};



// WEBPACK FOOTER //
// ./src/utils/offline.js